export default __webpack_public_path__ + "static/media/Icon-Undo.630a8a1e.svg";